/** Pure helpers shared by server and web — no DB access here. */

const FREEMAIL = new Set([
  "gmail.com", "googlemail.com", "gmx.at", "gmx.net", "gmx.de", "web.de", "hotmail.com", "outlook.com", "live.com",
  "icloud.com", "me.com", "yahoo.com", "aon.at", "a1.net", "chello.at", "proton.me", "protonmail.com",
]);

/** "https://www.Foo.at/x", "anna@foo.at", "FOO.AT." → "foo.at"; anything that isn't a hostname → null. */
export function normalizeDomain(input: string): string | null {
  let s = input.trim().toLowerCase();
  if (!s) return null;
  if (s.includes("@")) s = s.slice(s.lastIndexOf("@") + 1);
  s = s.replace(/^[a-z][a-z0-9+.-]*:\/\//, "").split(/[/?#]/)[0].replace(/:\d+$/, "").replace(/^www\./, "").replace(/\.$/, "");
  return /^[a-z0-9-]+(\.[a-z0-9-]+)+$/.test(s) ? s : null;
}

/** The website's domain, else the most common non-freemail domain among contact e-mails. */
export function suggestDomain(website: string | null, contactEmails: string[]): string | null {
  const fromSite = website ? normalizeDomain(website) : null;
  if (fromSite) return fromSite;
  const counts = new Map<string, number>();
  for (const e of contactEmails) {
    const d = normalizeDomain(e);
    if (d && !FREEMAIL.has(d)) counts.set(d, (counts.get(d) ?? 0) + 1);
  }
  let best: string | null = null;
  for (const [d, n] of counts) if (best === null || n > counts.get(best)!) best = d;
  return best;
}

/** Case-, accent- and punctuation-insensitive key for fuzzy name matching. */
export function searchKey(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^\p{L}\p{N}]/gu, "");
}
